module.exports = __webpack_public_path__ + "img/RH_1@2x-100.82fafafb.jpg";